module.exports = function () {
    return {
        restrict: 'E',
        template: require('./schema-markup-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/schema-markup/schema-markup-directive.js
 **/